/**
 * The chapter's syntax tree inside the editor state (decision 36, ADR 2: parsed once, incrementally, by the one
 * parser). Every transaction that changes the text reparses it through part 02's `reparseChapter`, reusing what the
 * edit left untouched, so the tree always equals a full parse of the editor's text (table E, E2).
 */
import { parseChapter, reparseChapter } from '@cockatrice/core';
import type { ParsedChapter, TextChange } from '@cockatrice/core';
import { StateField } from '@codemirror/state';
import type { ChangeSet } from '@codemirror/state';

/** A CodeMirror change set as part 02's changes: in the old text's positions, sorted, not overlapping. */
export function textChanges(changes: ChangeSet): TextChange[] {
  const result: TextChange[] = [];
  changes.iterChanges((fromA, toA, _fromB, _toB, inserted) => {
    result.push({ from: fromA, to: toA, insert: inserted.toString() });
  });
  return result;
}

/** The parsed chapter: the editor's text and its tree. */
export const chapterField: StateField<ParsedChapter> = StateField.define<ParsedChapter>({
  create: (state) => parseChapter(state.doc.toString()),
  update: (parsed, transaction) => (transaction.docChanged ? reparseChapter(parsed, textChanges(transaction.changes)) : parsed),
});
